import { apiClient } from "./api";

// NexBe Sign SDK 서명 콘텐츠 타입
export interface SignedContent {
  content_id: string;
  signed_content: string;
  signed_datetime: string;
}

// NexBe Sign SDK 인증 응답 데이터 타입
export interface NexBeSignAuthResponse {
  ca_code: string; // 인증기관 코드 (예: "ktpass")
  ca_std_yn: boolean; // 인증기관 표준 여부
  code: number; // 응답 코드 (200: 성공)
  encrypted: boolean; // 암호화 여부
  message: string; // 응답 메시지
  notified_at: string | null; // 알림 시간
  nxbs_tx_id: string; // NexBe 트랜잭션 ID
  options: Record<string, unknown> | null; // 추가 옵션
  rejected_at: string | null; // 거부 시간
  requested_at: string; // 요청 시간
  result: unknown | null; // 결과 데이터
  signed_at: string; // 서명 시간
  signed_content_list: SignedContent[]; // 서명된 콘텐츠 목록
  site_tx_id: string; // 사이트 트랜잭션 ID
  status: "signed" | "rejected" | "pending" | "expired"; // 상태
  tx_id: string; // 트랜잭션 ID
  viewed_at: string; // 조회 시간
}

export interface OmniAuthApiResponse {
  success: boolean;
  data?: Record<string, unknown>; // 백엔드에서 처리된 데이터
  error?: string;
}

export interface TransmissionPostRequest {
  provideInstitutionTransmissionList: Array<{
    provideInstitutionNo: string;
    signatureResult: SignatureResultDto | null;
  }>;
}

// 전자서명 결과 DTO
export interface SignatureResultDto {
  txId: string;
  agreementDate: string;
  transmissionDemandPurpose: string;
  thirdPartyProvisionAgreementYN: string;
  regularTransferYN: string;
  regularTransferCycle: string | null;
  transmissionDemandAgreementDateTime: string;
  transmissionDemandAgreementEndDate: string;
  holdUtilizationPeriod: string;
  provideInstitutionNo: string;
  datasetCodeList: string[];
  consent: string;
  siteTxId: string;
  caCode: string;
  contentId: string | null;
  signedContent: string;
  userIp: string;
}

export interface TransmissionPutRequest {
  provideInstitutionNo: string;
  signatureResult: SignatureResultDto;
}

class OmniAuthService {
  /**
   * 통합 전송 API - TransmissionPostRequest를 직접 전송 (여러 기관 생성)
   * @param request - TransmissionPostRequest 형식의 요청 데이터
   * @returns 백엔드 처리 결과
   */
  async submitTransmission(
    request: TransmissionPostRequest
  ): Promise<OmniAuthApiResponse> {
    try {
      const response = await apiClient.post<void>("/transmission", request);

      if (response.success) {
        return {
          success: true,
          data: {},
        };
      } else {
        return {
          success: false,
          error: response.message || "전송 처리에 실패했습니다.",
        };
      }
    } catch (error) {
      console.error("Transmission submission error:", error);
      throw error;
    }
  }

  /**
   * 단일 기관 전송 API - PUT 요청으로 단일 기관 연결 생성
   * @param request - TransmissionPutRequest 형식의 요청 데이터
   * @returns 백엔드 처리 결과
   */
  async createSingleTransmission(
    request: TransmissionPutRequest
  ): Promise<OmniAuthApiResponse> {
    try {
      const response = await apiClient.put<void>("/transmission", request);

      if (response.success) {
        return {
          success: true,
          data: {},
        };
      } else {
        return {
          success: false,
          error: response.message || "전송 처리에 실패했습니다.",
        };
      }
    } catch (error) {
      console.error("Single transmission creation error:", error);
      throw error;
    }
  }
}

export const omniAuthService = new OmniAuthService();
export default omniAuthService;
